module.exports = __webpack_public_path__ + "img/12.3cf93e67.jpeg";